export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png'] as const;
export const MAX_PHOTO_SIZE_BYTES = 2 * 1024 * 1024;

export type ProviderPhotoValidationResult =
  | { ok: true }
  | { ok: false; reason: string };

export function validateProviderPhoto(file: File): ProviderPhotoValidationResult {
  const allowed: readonly string[] = ALLOWED_IMAGE_TYPES;
  if (!allowed.includes(file.type)) {
    return { ok: false, reason: 'Faqat JPEG yoki PNG rasm yuklash mumkin' };
  }
  if (file.size > MAX_PHOTO_SIZE_BYTES) {
    return { ok: false, reason: "Rasm hajmi 2MB dan oshmasligi kerak" };
  }
  return { ok: true };
}
